import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import ErrorRoundedIcon from "@mui/icons-material/ErrorRounded";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import { Tooltip } from "@mui/material";
import { formatPercentage } from "@entrilia/shared/utilities/formatters";

type ConfidenceLevel = "high" | "medium" | "low";

const getConfidenceLevel = (confidence: number): ConfidenceLevel => {
  if (confidence >= 0.9) {
    return "high";
  }
  if (confidence >= 0.8) {
    return "medium";
  }
  return "low";
};

interface Props {
  confidence: number;
}

const ConfidenceIndicator = ({ confidence }: Props) => {
  const level = getConfidenceLevel(confidence);

  const iconProps = { sx: { fontSize: "1rem", cursor: "help" } };

  return (
    <Tooltip title={`Confidence: ${formatPercentage(confidence, { maximumFractionDigits: 0 })}`} arrow placement="top">
      {level === "high" ? (
        <CheckCircleRoundedIcon color="success" {...iconProps} />
      ) : level === "medium" ? (
        <WarningRoundedIcon color="warning" {...iconProps} />
      ) : (
        <ErrorRoundedIcon color="error" {...iconProps} />
      )}
    </Tooltip>
  );
};

export default ConfidenceIndicator;
